import * as TaskActions from '../constants/taskConstants';

export const setTaskList = (payload) => {
    return{
        type:TaskActions.SET_TASKS,
        data:payload
    }
}

export const setLastClickedElement = (payload) => {
    return {
        type:TaskActions.SET_LAST_CLICKED_ELEMENT,
        data:payload
    }
}

export const clearState = (payload) => {
    return {
        type:TaskActions.CLEAR_STATE,
        data:payload
    }
}